import { DemographicAgeChart, DemographicDeviceChart, DemographicGenderChart } from "@components";
import { History, Location } from "history";
import * as React from "react";
import { ChartPlaceholder } from "./ChartPlaceholder";
import { ReportLayout } from "./ReportLayout";
import { connect } from "react-redux";
import { AppState, isReportingOnlyCustomer } from "@store";
import { RouteComponentProps } from "react-router";

export interface AudienceReportComponentProps {
    history: History;
    location: Location;
    isFixedPriceCustomer: boolean;
}

function AudienceReportComponent(props: AudienceReportComponentProps) {
    return (
        <ReportLayout history={props.history} location={props.location} subtitle="Audience reports">
            {!props.isFixedPriceCustomer && (
                <ChartPlaceholder size="full">
                    <DemographicAgeChart />
                </ChartPlaceholder>
            )}
            {!props.isFixedPriceCustomer && (
                <ChartPlaceholder size="full">
                    <DemographicGenderChart />
                </ChartPlaceholder>
            )}
            <ChartPlaceholder size="full">
                <DemographicDeviceChart />
            </ChartPlaceholder>
        </ReportLayout>
    );
}

export const AudienceReportPage = connect((appState: AppState, ownProps: RouteComponentProps<{}>) => ({
    history: ownProps.history,
    location: ownProps.location,
    isFixedPriceCustomer: isReportingOnlyCustomer(appState)
}))(AudienceReportComponent);
